import axios from './axios';

const LOAN_AMOUNT_FILTER_KEYS = ['loan_amount_min', 'loan_amount_max'];

function toMinorUnits(val) {
  if (val == null) {
    return null;
  }
  const str = String(val).replace(/\s/g, '').replace(',', '.');
  if (str === '') {
    return null;
  }
  const num = Number(str);
  if (Number.isNaN(num)) {
    return null;
  }
  return String(Math.round(num * 100));
}

function serializeQueryValue(key, val) {
  if (LOAN_AMOUNT_FILTER_KEYS.includes(key)) {
    return toMinorUnits(val);
  }
  return val;
}

function appendQueryParams(search, params = {}) {
  Object.entries(params).forEach(([key, val]) => {
    if (val == null || val === '') {
      return;
    }
    search.set(key, serializeQueryValue(key, val));
  });
}

function buildListUrl(path, params = {}) {
  const search = new URLSearchParams();
  appendQueryParams(search, params);
  const qs = search.toString();
  return `${window.entityCabinetSettings.openApi.url}${path}${qs ? `?${qs}` : ''}`;
}

function buildUnauthorizedListUrl(params = {}) {
  return buildListUrl('/api/offer/unauthorized-list', params);
}

export default class OffersService {
  static createOffer(payload) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/offer/create', payload);
  }

  static getOffersList(params) {
    return axios.get(buildUnauthorizedListUrl(params));
  }

  static updateOffersList(params) {
    return axios.get(buildUnauthorizedListUrl(params));
  }

  static getLenderOffersList(params) {
    return axios.get(buildListUrl('/api/offer/personal-list', {
      page: params?.page,
      size: params?.size,
      status: params?.filter?.status
    }));
  }

  static getOffersArchivedList(params) {
    return axios.get(buildListUrl('/api/offer/personal-list/archived', {
      page: params?.page,
      size: params?.size,
      status: params?.filter?.status
    }));
  }

  static changeOfferStatus(data) {
    return axios.post(window.entityCabinetSettings.openApi.url + `/api/offer/change-status/${data.public_id}`, { status: data.status });
  }

  static deleteOffer(offerPublicId) {
    return axios.post(window.entityCabinetSettings.openApi.url + `/api/offer/archive/${offerPublicId}`);
  }
}
